import { RefObject, useEffect, useState } from 'react';

interface UseArticleReadingTimeParams {
  articleBodyRef: RefObject<HTMLElement | null>;
  articleKey: string;
}

export default function useArticleReadingTime({
  articleBodyRef,
  articleKey,
}: UseArticleReadingTimeParams): number {
  const [readingTimeMinutes, setReadingTimeMinutes] = useState(1);

  useEffect(() => {
    const articleBodyElement =
      articleBodyRef.current ?? document.querySelector('.article-body');

    if (!articleBodyElement) {
      return;
    }

    const textNodes = articleBodyElement.querySelectorAll(
      'p, li, h2, h3, blockquote',
    );
    const textContent =
      Array.from(textNodes)
        .map((node) => node.textContent?.trim() ?? '')
        .filter(Boolean)
        .join(' ') || articleBodyElement.innerText;
    const words = textContent.match(/\b[\w'-]+\b/g) ?? [];
    const averageWordsPerMinute = 150;

    setReadingTimeMinutes(
      Math.max(1, Math.ceil(words.length / averageWordsPerMinute)),
    );
  }, [articleBodyRef, articleKey]);

  return readingTimeMinutes;
}
